export default {"src":"/_next/static/media/cryptopedia_social_linkedin.5d02d7b5.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};